import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="customer-notice">
        <h4>Connect</h4>

        <address>
          Hong Kong Jin Heng Ye Trading Co., Limited <br /> RM 19, UNIT 12A,
          13/F, BLOCK 1, CAMEL PAINT BUILDING, 62 HOI YUEN ROAD, Kwun Tong, Hong
          Kong <br />
          <a href="mailto:west@autumncircle.website">
            west@autumncircle.website
          </a>
        </address>
      </div>
      <div className="footer-links">
        <Link to="/shipping" onClick={toTop}>
          Delivery
        </Link>
        <Link to="/privacy" onClick={toTop}>
          Privacy Policy
        </Link>
        <Link to="/terms" onClick={toTop}>
          Terms of Service
        </Link>
        <Link to="/returns" onClick={toTop}>
          Refund Policy
        </Link>
        <Link to="/faqs" onClick={toTop}>
          FAQs
        </Link>
        <Link to="/cookies" onClick={toTop}>
          Cookie Policy
        </Link>
      </div>
      <div className="payment-methods" aria-label="Supported payment methods">
        <span>Secure payments supported:</span>
        <b>VISA</b>
        <b>Mastercard</b>
        <b>AMEX</b>
        <b>Discover</b>
      </div>
    </footer>
  );
}

export default Footer;
